module.exports = __webpack_public_path__ + "static/media/delete-bin.43bc112e.svg";